<template>
  <div>
    <el-card style="position: relative">
      <p class="title_p">基本配置</p>
      <el-button
        type="primary"
        class="edit_position"
        @click="basicConfigFlag = !basicConfigFlag"
        size="mini"
        >编 辑</el-button
      >
      <el-button
        type="primary"
        class="btn_position"
        @click="addDict()"
        size="mini"
        >添 加</el-button
      >

      <el-form class="basic_config">
        <el-form-item
          v-for="item in basicConfig"
          :label="item.dicName"
          :key="item.id"
          label-width="250px"
        >
          <el-input
            :disabled="basicConfigFlag"
            v-model="item.dicValue"
            style="max-width: 500px; min-width: 200px"
          ></el-input>
          <el-button
            style="right: 100px"
            type="primary"
            class="btn_position"
            :disabled="basicConfigFlag"
            @click="basicConfigs(item)"
            size="mini"
            >确定</el-button
          >
          <el-button
            style="margin-left: 30px"
            type="danger"
            class="btn_position"
            :disabled="basicConfigFlag"
            @click="deleteId(item.id)"
            size="mini"
            >删除</el-button
          >
        </el-form-item>
      </el-form>
    </el-card>

    <el-dialog
      class="confirms"
      title="添加"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-card class="box-card">
        <el-form label-width="100px">
          <el-form-item label="编码：">
            <el-input v-model="dataMap.dicCode"></el-input>
          </el-form-item>
          <el-form-item label="名称：">
            <el-input v-model="dataMap.dicName"></el-input>
          </el-form-item>
          <el-form-item label="上级：">
            <el-select v-model="dataMap.parentId" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.dicName"
                :label="item.dicName"
                :value="item.parentId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="值：">
            <el-input v-model="dataMap.dicValue"></el-input>
          </el-form-item>
          <el-form-item label="字符string：">
            <el-input v-model="dataMap.divValueType"></el-input>
          </el-form-item>
        </el-form>
      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="handleClose()">取 消</el-button>
        <el-button type="primary" size="mini" @click="add_edit()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { AxiosAjax } from "../../js/axios.config";

export default {
  data() {
    return {
      basicConfigFlag: true,
      basicConfig: [],

      dataMap: {
        dicCode: "",
        dicName: "",
        parentId: "",
        dicValue: "",
        divValueType: "",
      },
      options: [],
      dialogVisible: false,
    };
  },
  methods: {
    initData() {
      let _this = this;
      this.options = [];
      this.options.push({ parentId: 0, dicName: "父级" });

      AxiosAjax({
        url: "/calculation/dic",
        success: function (res) {
          _this.basicConfig = res.data.data;
          _this.basicConfig.forEach((item) => {
            if (item.parentId == 0) {
              _this.options.push(item);
            }
          });
        },
      });
    },
    basicConfigs(item) {
      const _this = this;
      AxiosAjax({
        url: "/calculation/dic",
        method: "put",
        data: item,
        success: function (res) {
          if (res.data.msg) {
            _this.initData();
          }
        },
      });
    },
    addDict() {
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    add_edit() {
      const _this = this;
      AxiosAjax({
        url: "/calculation/dic",
        method: "post",
        data: _this.dataMap,
        success: function (res) {
          if (res.data.msg) {
            _this.dialogVisible = false;
            _this.dataMap = {};
            _this.initData();
          }
        },
      });
    },
    deleteId(id) {
      let _this = this;
      this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          _this.deleteDict(id);
        })
        .catch(() => {});
    },
    deleteDict(id) {
      const _this = this;
      AxiosAjax({
        url: "/calculation/dic/" + id,
        method: "delete",
        success: function (res) {
          _this.initData();
        },
      });
    },
  },
  mounted() {
    this.initData();
  },
};
</script>
<style scoped>
.title_p {
  text-align: left;
  border-bottom: 1px solid #ccc;
  margin-bottom: 20px;
  padding-bottom: 16px;
  font-weight: 600;
}
.btn_position {
  position: absolute;
  top: 12px;
  right: 20px;
}
.edit_position {
  position: absolute;
  top: 12px;
  right: 120px;
}
.basic_config /deep/ .el-form-item__content {
  text-align: left;
}
.el-card {
  margin: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/Calculation/CalculationMoreParameters.vue